import { useContext } from "react";

import { NotificationContext } from "@contexts/notification";
import { INotificationContext } from "@type";

export const useNotification = (): INotificationContext => {
  return useContext(NotificationContext);
};
